import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-md-row mt-6" }
const _hoisted_2 = { class: "d-flex justify-content-center justify-content-md-start mb-8 mb-md-0 me-md-8" }
const _hoisted_3 = {
  class: "mb-4",
  style: {"position":"relative","display":"inline-block","max-width":"200px","max-height":"200px"}
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "avatar-uploader-icon d-flex align-items-center justify-content-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-camera fa-1x" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "d-flex flex-column mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_upload, {
          class: "avatar-uploader",
          "show-file-list": false,
          "on-success": _ctx.handleAvatarSuccess,
          "before-upload": _ctx.beforeAvatarUpload,
          "http-request": _ctx.requestCropper
        }, {
          default: _withCtx(() => [
            (_ctx.hasAvatar)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.userStore.profile.avatar,
                  class: "avatar",
                  width: "150",
                  height: "300",
                  alt: ""
                }, null, 8, _hoisted_4))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          ]),
          _: 1
        }, 8, ["on-success", "before-upload", "http-request"]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.hasAvatar)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                onClick: _ctx.removePhoto,
                type: "danger"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Remove Photo")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ])), [
    [_directive_loading, _ctx.isLoading]
  ])
}